"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorCardModuleUi = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const ui_1 = require("../_abstract/ui");
const ui_2 = require("../_components/ui");
const _partials_1 = require("./_partials");
/**
 * @author Michał Rossian <michal.rossian@movecloser.pl>
 */
let AuthorCardModuleUi = class AuthorCardModuleUi extends ui_1.AbstractModuleUi {
    constructor() {
        super(...arguments);
        this.author = null;
    }
    async fetchRelated() {
        try {
            const author = await this.relatedService.resolve(this.module.content.authorRelated);
            if (author.isPageActive) {
                this.author = author;
            }
            else {
                this.onError(new Error('Author page does not exist'));
            }
        }
        catch (error) {
            this.onError(error);
        }
    }
};
AuthorCardModuleUi = __decorate([
    vue_property_decorator_1.Component({
        name: 'AuthorCardModuleUi',
        components: { Editor: _partials_1.Editor, LineHeader: ui_2.LineHeader },
        async created() {
            await this.fetchRelated();
        },
        template: `
    <div class="author-view">
      <LineHeader v-if="module.content.canShowHeader" class="mb-5 mb-md-6">{{ $t('modules.author.title') }}</LineHeader>

      <Editor v-if="author" :editor="author" :showAbout="module.content.showAbout" :isLazy="module.isLazyLoaded"
              nameTag="h1" class="author-view__author pb-md-6 border-bottom"/>

      <div v-if="!module.content.showAbout" class="row justify-content-center justify-content-lg-start">
        <div v-if="author" v-html="author.description" class="col-12 col-lg-8 my-5 my-md-6 fs-medium"/>
      </div>
    </div>
  `
    })
], AuthorCardModuleUi);
exports.AuthorCardModuleUi = AuthorCardModuleUi;
exports.default = AuthorCardModuleUi;
//# sourceMappingURL=AuthorCard.ui.js.map